class JepOffersLayer extends Layer {

    constructor(mapGL, isVisible = false, selectionMode = false) {
      super(mapGL, isVisible);

      this.name = 'jepoffers';
      this.minZoom =6;
      this.layerIds = ['jep-clusters', 'jep-cluster-count', 'jep-unclustered-point'];

      this.isClickable = true;
      this.selectionMode = selectionMode;

      var postData = {};

      if (typeof offerIds !== 'undefined') {
        postData.offerIds = offerIds;
      }

      var thisLayer = this;
      $.post('/?type=1470243311&no_cache=1', postData, "json")
        .done(function(data) {
          if(data){
            thisLayer.offers = data;
            thisLayer.load();
          }
        });
    }

    fitBounds(features) {
      let bounds = new maplibregl.LngLatBounds(features[0].geometry.coordinates, features[0].geometry.coordinates);

      var length = features.length;
      for(var i=0; i < length; i++) {
        bounds.extend(features[i].geometry.coordinates);
      }

      this.mapGL.getMapObject().fitBounds(bounds, {padding: 75});
    }

    load() {
      this.mapGL.getMapObject().addSource(this.name + '-source', {
        'type': 'geojson',
        'data': this.offers,
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 70
      });

      // Clusters
      this.mapGL.getMapObject().addLayer({
        'id': this.layerIds[0],
        'type': 'circle',
        'source': this.name + '-source',
        'filter': ["has", "point_count"],
        'paint': {
          'circle-color': '#273375',
          'circle-radius': 15
        },
        'layout': {
          'visibility': this.isVisible ? 'visible' : 'none'
        },
        'minzoom': this.minZoom,
      });

      // Cluster count
      this.mapGL.getMapObject().addLayer({
        'id': this.layerIds[1],
        'type': 'symbol',
        'source': this.name + '-source',
        'filter': ['has', 'point_count'],
        'paint': {
          'text-color': '#ffffff'
        },
        'layout': {
          'text-field': '{point_count_abbreviated}',
          'text-size': 12,
          'visibility': this.isVisible ? 'visible' : 'none'
        },
        'minzoom': this.minZoom,
      });

      // Unclustered point
      this.mapGL.getMapObject().addLayer({
        'id': this.layerIds[2],
        'type': 'symbol',
        'source': this.name + '-source',
        'filter': ["!has", "point_count"],
        'layout': {
          'icon-image': "poi-offre",
          'icon-allow-overlap': true,
          'visibility': this.isVisible ? 'visible' : 'none'
        },
        'minzoom': this.minZoom,
      });

      //this.fitBounds(this.offers.features);
      var thisLayer = this;

      this.mapGL.getMapObject().on('click', this.layerIds[2], function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();

        if (thisLayer.mapGL.popup.isOpen()) {
          thisLayer.mapGL.popup.remove();
        }

        var postData = {
          'offerId': e.features[0].properties.id,
          'selectionMode': ($('#selection-wrapper').length)? true : false
        };

        $.post('/?type=1470237122&no_cache=1', postData, "html")
          .done(function(data){
            if(data){
              thisLayer.mapGL.popup = new maplibregl.Popup({focusAfterOpen: false})
                .setLngLat(coordinates)
                .setHTML(data);

              thisLayer.mapGL.popup.addTo(thisLayer.mapGL.getMapObject());
            }
            $(".maplibregl-popup .star").on('click', function(e){
              e.preventDefault();

              let offerId = $(this).data('offerid');

              if(thisLayer.mapGL.popup.isOpen()) {
                thisLayer.mapGL.popup.remove();
              }

              if (thisLayer.selectionMode) {
                var matchingFeatures = thisLayer.offers.features.filter(function (feature){
                  return feature.properties.id !== offerId;
                });
                thisLayer.offers.features = matchingFeatures;

                // Update data source to remove unselected offer
                // Cant use setFilter method, clusters not able to be updated
                thisLayer.mapGL.getMapObject().getSource(thisLayer.name + '-source').setData(thisLayer.offers);
              }

              StarredOffers.updateStar(this);
            });
        });
      });

      if (!Utils.isMobileOrTablet()) {
        this.mapGL.getMapObject().on('mouseenter', this.layerIds[2], function (e) {
          thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
          var coordinates = e.features[0].geometry.coordinates.slice();
          var tooltipContent = thisLayer.getTooltipContent(e.features[0]);

          if (thisLayer.mapGL.tooltip.isOpen()) {
            thisLayer.mapGL.tooltip.remove();
          }

          thisLayer.mapGL.tooltip.setLngLat(coordinates)
            .setHTML(tooltipContent)
            .addTo(thisLayer.mapGL.getMapObject());
        });

        this.mapGL.getMapObject().on('mousemove', this.layerIds[2], function (e) {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var tooltipContent = thisLayer.getTooltipContent(e.features[0]);
          thisLayer.mapGL.tooltip.setLngLat(coordinates).setHTML(tooltipContent);
          if (!thisLayer.mapGL.tooltip.isOpen()) {
            thisLayer.mapGL.tooltip.addTo(thisLayer.mapGL.getMapObject());
          }
        });

        this.mapGL.getMapObject().on('mouseleave', this.layerIds[2], function () {
          thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
          thisLayer.mapGL.tooltip.remove();
        });
      }

      this.mapGL.getMapObject().on('click', this.layerIds[1], function (e) {

        var features = thisLayer.mapGL.getMapObject().queryRenderedFeatures(e.point, {
          layers: [thisLayer.layerIds[1]]
        });
        var clusterId = features[0].properties.cluster_id;

        thisLayer.mapGL.getMapObject().getSource(thisLayer.name + '-source').getClusterExpansionZoom(
          clusterId,
          function (err, zoom) {
            if (err) {
              return;
            }

            thisLayer.mapGL.getMapObject().easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });

      this.mapGL.getMapObject().on('mouseenter', this.layerIds[1], function () {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
      });

      this.mapGL.getMapObject().on('mouseleave', this.layerIds[1], function () {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
      });
    }

    getTooltipContent(feature) {
      var tooltipContent = '<div class="map-tooltip">' + feature.properties.nom + '</div>';
      return tooltipContent;
    }
  }
